<script>
  import { sankey, sankeyLinkHorizontal } from 'd3-sankey';
  import { scaleOrdinal } from 'd3-scale';
  import { json } from 'd3-fetch';
  import { onMount } from 'svelte';

  // Data and dimensions
  let data = $state({ nodes: [], links: [] });
  let width = $state(800);
  const height = 700;
  const margin = { top: 20, right: 20, bottom: 20, left: 20 };

  // Color scale for nodes
  const colorScale = scaleOrdinal().range([
    '#66c2a5',
    '#fc8d62',
    '#8da0cb',
    '#e78ac3',
    '#a6d854',
    '#ffd92f',
    '#e5c494',
    '#b3b3b3'
  ]);

  // Sankey generator
  let sankeyGenerator = $derived(
    sankey()
      .nodeWidth(15)
      .nodePadding(10)
      .extent([
        [margin.left, margin.top],
        [width - margin.right, height - margin.bottom]
      ])
  );

  // Process data through sankey generator
  let sankeyData = $derived(
    data.nodes.length === 0
      ? null
      : sankeyGenerator({
          nodes: data.nodes.map((d) => ({ ...d })),
          links: data.links.map((d) => ({ ...d }))
        })
  );

  // Link generator
  const linkGenerator = sankeyLinkHorizontal();

  // Load data on mount
  onMount(async () => {
    try {
      data = await json(
        'https://gist.githubusercontent.com/kunalb/4647670/raw/a4b180a30763b555c43a0979527e93dc4076d6ce/energy.json'
      );
    } catch (error) {
      console.error('Error loading JSON:', error);
    }
  });
</script>

<div
  class="relative min-w-full max-w-4xl rounded-xl p-6"
  bind:clientWidth={width}>
  <h2 class="text-xl font-bold text-gray-200 mb-6 text-center">
    Energy Flow Diagram
  </h2>
  {#if sankeyData}
    <svg {width} {height}>
      <!-- Links -->
      {#each sankeyData.links as link}
        <path
          d={linkGenerator(link)}
          fill="none"
          stroke={colorScale(link.source.name)}
          stroke-opacity="0.4"
          stroke-width={Math.max(1, link.width)}
          class="link" />
      {/each}

      <!-- Nodes -->
      {#each sankeyData.nodes as node}
        <g class="node" transform="translate({node.x0},{node.y0})">
          <rect
            height={node.y1 - node.y0}
            width={node.x1 - node.x0}
            fill={colorScale(node.name)}
            class="node-rect">
            <title>{node.name}: {node.value}</title>
          </rect>
        </g>
      {/each}

      {#each sankeyData.nodes as node}
        <text
          x={node.x0 < width / 2 ? node.x1 + 6 : node.x0 - 6}
          y={node.y0 + (node.y1 - node.y0) / 2}
          dy="0.35em"
          text-anchor={node.x0 < width / 2 ? 'start' : 'end'}
          class="fill-gray-200 text-xs">
          {node.name}
        </text>
      {/each}
    </svg>
  {/if}
</div>

<style>
  .link {
    transition: stroke-opacity 200ms ease-in-out;
  }

  .link:hover {
    stroke-opacity: 0.8;
  }

  .node-rect {
    transition: opacity 200ms ease-in-out;
    opacity: 0.8;
  }

  .node-rect:hover {
    opacity: 1;
  }
</style>
